<script setup>
import { computed } from 'vue';
const props = defineProps({
  count: Number,
  totalValue: Number,
  totalItems: Number,
  title: String,
});

const percent = computed(() => props.totalItems ? ((props.count / props.totalItems) * 100).toFixed(1) : '0');
const avgValue = computed(() => props.count ? props.totalValue / props.count : 0);
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <div
      class="flex items-center gap-2 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 bg-white dark:bg-slate-900 text-xs text-slate-700 dark:text-slate-200"
      title="Cards que não estão atribuídos a nenhum agente."
    >
      <span class="mr-1"><svg xmlns='http://www.w3.org/2000/svg' class='inline w-4 h-4 text-slate-400' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M12 14c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4zm0-2a4 4 0 100-8 4 4 0 000 8z'/></svg></span>
      <span>Cards:</span>
      <span class="font-semibold">{{ count }}</span>
      <span>| {{ percent }}%</span>
      <span>| Valor Total:</span>
      <span class="font-semibold">{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(totalValue) }}</span>
      <span>| Valor Médio:</span>
      <span class="font-semibold">{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(avgValue) }}</span>
    </div>
  </div>
</template> 